// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5dc05116","133":"54842de5","186":"1f9a5c00","272":"2f5d4357","372":"09aeaca8","377":"cfffa880","738":"ae620bad","841":"d2cc44a3","856":"cc3c7b39"}[chunkId] + ".chunk.js";
};